import { useEffect, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Button from './Button'
import TextField from '../utils/TextField'
import { Alert } from '../utils/Alert'
import { firestore } from '../firebase'

export default function AiConfigSettings() {

	const [data, setData] = useState<FirebaseFirestore.DocumentData | null>(null)
	const [showLoader, setShowLoader] = useState(false)

	useEffect(() => {
		fetchSettings()
	}, [])

	if (data == null) {
		return (
			<div style={{
				padding: 30,
				textAlign: 'center'
			}}>
				<CircularProgress />
			</div>
		)
	}

	return (
		<div style={{
			padding: 15
		}}>
			<TextField
				style={{
					marginBottom: 15
				}}
				inputStyle={{
					width: 800,
					height: 800,
					padding: 15,
				}}
				label='System Instruction'
				multiline
				value={data.systemInstruction ?? ''}
				onChangeText={(value) => {
					setData({ ...data, systemInstruction: value })
				}} />
			<div style={{
				display: 'flex',
				alignItems: 'center'
			}}>
				<Button
					containerStyle={{
						width: 200
					}}
					disabled={showLoader}
					onPress={onPressSave}
					title='Save' />
				{showLoader && (
					<CircularProgress size={20} style={{ marginLeft: 15 }} />
				)}
			</div>
		</div>
	)

	async function fetchSettings() {
		setShowLoader(true)
		try {
			const docSnapshot = await firestore().collection('settings').doc('ai-config').get()
			setData(docSnapshot.data() ?? {})
		} catch (error) {
			Alert.alert('Error Fetching Settings', String(error))
		}
		setShowLoader(false)
	}

	async function onPressSave() {
		setShowLoader(true)
		try {
			if (data)
				await firestore().collection('settings').doc('ai-config').set(data, { merge: true })
		} catch (error) {
			Alert.alert('Error Saving Settings', String(error))
		}
		setShowLoader(false)
	}
}
